var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSmallDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 15,
    viewBox: "0 0 299 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 15,
    fill: "#3B494D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    width: 2,
    height: 15,
    fill: "#3B494D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 295,
    height: 2,
    fill: "#3B494D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSmallDivider);
export default __webpack_public_path__ + "static/media/HomeSmallDivider.790c4409c62bf63117f34e710bf0d8ff.svg";
export { ForwardRef as ReactComponent };